import { HomeUIProvider } from "./HomeUIContext";
import { HomeUIRootPages } from "./HomeUIRootPages";
import { Educationpage } from "./pages/Educationpage";
import { HomePage } from "./pages/HomePage";
import { Profilepage } from "./pages/Profilepage";

export const HomeRoutes = [
  {
    path: "/",
    element: (
      <HomeUIProvider>
        <HomeUIRootPages>
          <HomePage />
        </HomeUIRootPages>
      </HomeUIProvider>
    ),
  },
  {
    path: "/profile",
    element: (
      <HomeUIProvider>
        <HomeUIRootPages>
          <Profilepage />
        </HomeUIRootPages>
      </HomeUIProvider>
    ),
  },
  {
    path: "/education",
    element: (
      <HomeUIProvider>
        <HomeUIRootPages>
          <Educationpage />
        </HomeUIRootPages>
      </HomeUIProvider>
    ),
  },
  {
    path: "/help",
    element: (
      <HomeUIProvider>
        <HomeUIRootPages>
          <Profilepage />
        </HomeUIRootPages>
      </HomeUIProvider>
    ),
  },
];
